var items = {
  "block.minecraft.air": "adhar",
  "block.minecraft.stone": "clach",
  "block.minecraft.granite": "gaireal",
  "block.minecraft.polished_granite": "gaireal lìomhta",
  "block.minecraft.diorite": "dìorait",
  "block.minecraft.polished_diorite": "dìorait lìomhta",
  "block.minecraft.andesite": "andasait",
  "block.minecraft.polished_andesite": "andasait lìomhta",
  "block.minecraft.grass_block": "bloca feòir",
  "block.minecraft.dirt": "ùir",
  "block.minecraft.coarse_dirt": "ùir gharbh",
  "block.minecraft.podzol": "podsol",
  "block.minecraft.crimson_nylium": "nilium crò-dhearg",
  "block.minecraft.warped_nylium": "nilium saobh",
  "block.minecraft.cobblestone": "clach-chàsaidh",
  "block.minecraft.oak_planks": "dèilean daraich",
  "block.minecraft.spruce_planks": "dèilean giuthais",
  "block.minecraft.birch_planks": "dèilean beithe",
  "block.minecraft.jungle_planks": "dèilean dlùth-choille",
  "block.minecraft.acacia_planks": "dèilean sitta",
  "block.minecraft.dark_oak_planks": "dèilean daraich dhuirch",
  "block.minecraft.crimson_planks": "dèilean crò-dhearg",
  "block.minecraft.warped_planks": "dèilean saobha",
  "block.minecraft.oak_sapling": "fiùran daraich",
  "block.minecraft.spruce_sapling": "fiùran giuthais",
  "block.minecraft.birch_sapling": "fiùran beithe",
  "block.minecraft.jungle_sapling": "fiùran dlùth-choille",
  "block.minecraft.acacia_sapling": "fiùran sitta",
  "block.minecraft.dark_oak_sapling": "fiùran daraich dhuirch",
  "block.minecraft.bedrock": "fo-chreag",
  "block.minecraft.sand": "gainmheach",
  "block.minecraft.red_sand": "gainmheach ruadh",
  "block.minecraft.gravel": "grinneal",
  "block.minecraft.gold_ore": "clach-òir",
  "block.minecraft.iron_ore": "clach-iarainn",
  "block.minecraft.coal_ore": "clach-ghuail",
  "block.minecraft.nether_gold_ore": "clach-òir nether",
  "block.minecraft.oak_log": "loga daraich",
  "block.minecraft.spruce_log": "loga giuthais",
  "block.minecraft.birch_log": "loga beithe",
  "block.minecraft.jungle_log": "loga dlùth-choille",
  "block.minecraft.acacia_log": "loga sitta",
  "block.minecraft.dark_oak_log": "loga daraich dhuirch",
  "block.minecraft.crimson_stem": "gas crò-dhearg",
  "block.minecraft.warped_stem": "gas saobh",
  "block.minecraft.stripped_oak_log": "loga daraich rùisgte",
  "block.minecraft.stripped_spruce_log": "loga giuthais rùisgte",
  "block.minecraft.stripped_birch_log": "loga beithe rùisgte",
  "block.minecraft.stripped_jungle_log": "loga dlùth-choille rùisgte",
  "block.minecraft.stripped_acacia_log": "loga sitta rùisgte",
  "block.minecraft.stripped_dark_oak_log": "loga daraich dhuirch rùisgte",
  "block.minecraft.stripped_crimson_stem": "gas crò-dhearg rùisgte",
  "block.minecraft.stripped_warped_stem": "gas saobh rùisgte",
  "block.minecraft.stripped_oak_wood": "fiodh daraich rùisgte",
  "block.minecraft.stripped_spruce_wood": "fiodh giuthais rùisgte",
  "block.minecraft.stripped_birch_wood": "fiodh beithe rùisgte",
  "block.minecraft.stripped_jungle_wood": "fiodh dlùth-choille rùisgte",
  "block.minecraft.stripped_acacia_wood": "fiodh sitta rùisgte",
  "block.minecraft.stripped_dark_oak_wood": "fiodh daraich dhuirch rùisgte",
  "block.minecraft.stripped_crimson_hyphae": "ròineagan crò-dhearg rùisgte",
  "block.minecraft.stripped_warped_hyphae": "ròineagan saobha rùisgte",
  "block.minecraft.oak_wood": "fiodh daraich",
  "block.minecraft.spruce_wood": "fiodh giuthais",
  "block.minecraft.birch_wood": "fiodh beithe",
  "block.minecraft.jungle_wood": "fiodh dlùth-choille",
  "block.minecraft.acacia_wood": "fiodh sitta",
  "block.minecraft.dark_oak_wood": "fiodh daraich dhuirch",
  "block.minecraft.crimson_hyphae": "ròineagan crò-dhearg",
  "block.minecraft.warped_hyphae": "ròineagan saobha",
  "block.minecraft.oak_leaves": "duilleach daraich",
  "block.minecraft.spruce_leaves": "duilleach giuthais",
  "block.minecraft.birch_leaves": "duilleach beithe",
  "block.minecraft.jungle_leaves": "duilleach dlùth-choille",
  "block.minecraft.acacia_leaves": "duilleach sitta",
  "block.minecraft.dark_oak_leaves": "duilleach daraich dhuirch",
  "block.minecraft.sponge": "spong",
  "block.minecraft.wet_sponge": "spong fliuch",
  "block.minecraft.glass": "glainne",
  "block.minecraft.lapis_ore": "clach cloiche-copair",
  "block.minecraft.lapis_block": "bloca cloiche-copair",
  "block.minecraft.dispenser": "bloca tilgeil",
  "block.minecraft.sandstone": "clach-ghainmhich",
  "block.minecraft.chiseled_sandstone": "clach-ghainmhich ghilbichte",
  "block.minecraft.cut_sandstone": "clach-ghainmhich gheàrrte",
  "block.minecraft.note_block": "bloca-phong",
  "block.minecraft.powered_rail": "rèile-dealain",
  "block.minecraft.detector_rail": "rèile-mothachaidh",
  "block.minecraft.sticky_piston": "loinid-tharraing",
  "block.minecraft.cobweb": "oige",
  "block.minecraft.grass": "feur",
  "block.minecraft.fern": "raineach",
  "block.minecraft.dead_bush": "preas marbh",
  "block.minecraft.seagrass": "bilearach-mara",
  "block.minecraft.sea_pickle": "piceal na mara",
  "block.minecraft.piston": "loinid",
  "block.minecraft.white_wool": "clòimh gheal",
  "block.minecraft.orange_wool": "clòimh orains",
  "block.minecraft.magenta_wool": "clòimh mhaidèanta",
  "block.minecraft.light_blue_wool": "clòimh bhàn-ghorm",
  "block.minecraft.yellow_wool": "clòimh bhuidhe",
  "block.minecraft.lime_wool": "clòimh bhàn-uaine",
  "block.minecraft.pink_wool": "clòimh bhàn-dearg",
  "block.minecraft.gray_wool": "clòimh ghlas",
  "block.minecraft.light_gray_wool": "clòimh liath",
  "block.minecraft.cyan_wool": "clòimh shaidhean",
  "block.minecraft.purple_wool": "clòimh phurpaidh",
  "block.minecraft.blue_wool": "clòimh ghorm",
  "block.minecraft.brown_wool": "clòimh dhonn",
  "block.minecraft.green_wool": "clòimh uaine",
  "block.minecraft.red_wool": "clòimh dhearg",
  "block.minecraft.black_wool": "clòimh dhubh",
  "block.minecraft.dandelion": "beàrnan-brìde",
  "block.minecraft.poppy": "crom-lus",
  "block.minecraft.blue_orchid": "magairle ghorm",
  "block.minecraft.allium": "uinnean pearsach",
  "block.minecraft.azure_bluet": "gorm-lus",
  "block.minecraft.red_tulip": "tiuilip dhearg",
  "block.minecraft.orange_tulip": "tiuilip orains",
  "block.minecraft.white_tulip": "tiuilip bhàn",
  "block.minecraft.pink_tulip": "tiuilip bhàn-dearg",
  "block.minecraft.oxeye_daisy": "neòinean-mòr",
  "block.minecraft.cornflower": "gille-guirmein",
  "block.minecraft.lily_of_the_valley": "lilidh nan lòn",
  "block.minecraft.wither_rose": "ròs wither",
  "block.minecraft.brown_mushroom": "balgan-buachair donn",
  "block.minecraft.red_mushroom": "balgan-buachair dearg",
  "block.minecraft.crimson_fungus": "fungas crò-dhearg",
  "block.minecraft.warped_fungus": "fungas saobh",
  "block.minecraft.crimson_roots": "freumhan crò-dhearg",
  "block.minecraft.warped_roots": "freumhan saobha",
  "block.minecraft.nether_sprouts": "buinneagan nether",
  "block.minecraft.weeping_vines": "fìonain-chaoinidh",
  "block.minecraft.twisting_vines": "fìonain shnìomhanach",
  "block.minecraft.sugar_cane": "cuilc an t-siùcair",
  "block.minecraft.kelp": "ceilp",
  "block.minecraft.bamboo": "bambù",
  "block.minecraft.gold_block": "bloca òir",
  "block.minecraft.iron_block": "bloca iarainn",
  "block.minecraft.oak_slab": "leac daraich",
  "block.minecraft.spruce_slab": "leac giuthais",
  "block.minecraft.birch_slab": "leac beithe",
  "block.minecraft.jungle_slab": "leac dlùth-choille",
  "block.minecraft.acacia_slab": "leac sitta",
  "block.minecraft.dark_oak_slab": "leac daraich dhuirch",
  "block.minecraft.crimson_slab": "leac chrò-dhearg",
  "block.minecraft.warped_slab": "leac shaobh",
  "block.minecraft.stone_slab": "leac cloiche",
  "block.minecraft.smooth_stone_slab": "leac cloiche rèidh",
  "block.minecraft.sandstone_slab": "leac cloiche-gainmhich",
  "block.minecraft.cut_sandstone_slab": "leac cloiche-gainmhich geàrrte",
  "block.minecraft.petrified_oak_slab": "leac daraich a chaidh na chloich",
  "block.minecraft.cobblestone_slab": "leac cloiche-càsaidh",
  "block.minecraft.brick_slab": "leac bhreigichean",
  "block.minecraft.stone_brick_slab": "leac bhreigichean-cloiche",
  "block.minecraft.nether_brick_slab": "leac bhreigichean nether",
  "block.minecraft.quartz_slab": "leac eiteige",
  "block.minecraft.red_sandstone_slab": "leac cloiche-gainmhich ruaidhe",
  "block.minecraft.cut_red_sandstone_slab": "leac cloiche-gainmhich ruaidhe geàrrte",
  "block.minecraft.purpur_slab": "leac purpur",
  "block.minecraft.prismarine_slab": "leac priosaim-mhara",
  "block.minecraft.prismarine_brick_slab": "leac bhreigichean priosaim-mhara",
  "block.minecraft.dark_prismarine_slab": "leac priosaim-mhara dhuirch",
  "block.minecraft.smooth_quartz": "bloc èiteige rèidh",
  "block.minecraft.smooth_red_sandstone": "clach-ghainmhich ruadh rèidh",
  "block.minecraft.smooth_sandstone": "clach-ghainmhich rèidh",
  "block.minecraft.smooth_stone": "clach rèidh",
  "block.minecraft.bricks": "breigichean",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "sgeilp leabhraichean",
  "block.minecraft.mossy_cobblestone": "clach-chàsaidh chòinneachail",
  "block.minecraft.obsidian": "oibsidian",
  "block.minecraft.torch": "lòchran",
  "block.minecraft.end_rod": "slat end",
  "block.minecraft.chorus_plant": "lus-sèiste",
  "block.minecraft.chorus_flower": "flùr-sèiste",
  "block.minecraft.purpur_block": "bloca purpur",
  "block.minecraft.purpur_pillar": "colbh purpur",
  "block.minecraft.purpur_stairs": "staidhre purpur",
  "block.minecraft.spawner": "gineadair",
  "block.minecraft.oak_stairs": "staidhre daraich",
  "block.minecraft.chest": "ciste",
  "block.minecraft.diamond_ore": "clach-daoimein",
  "block.minecraft.diamond_block": "bloca daoimein",
  "block.minecraft.crafting_table": "bòrd-ciùird",
  "block.minecraft.farmland": "fearann-tuathanais",
  "block.minecraft.furnace": "fùirneis",
  "block.minecraft.ladder": "fàradh",
  "block.minecraft.rail": "rèile",
  "block.minecraft.cobblestone_stairs": "staidhre cloiche-càsaidh",
  "block.minecraft.lever": "luamhan",
  "block.minecraft.stone_pressure_plate": "pleata-brùthaidh cloiche",
  "block.minecraft.oak_pressure_plate": "pleata-brùthaidh daraich",
  "block.minecraft.spruce_pressure_plate": "pleata-brùthaidh giuthais",
  "block.minecraft.birch_pressure_plate": "pleata-brùthaidh beithe",
  "block.minecraft.jungle_pressure_plate": "pleata-brùthaidh dlùth-choille",
  "block.minecraft.acacia_pressure_plate": "pleata-brùthaidh sitta",
  "block.minecraft.dark_oak_pressure_plate": "pleata-brùthaidh daraich dhuirch",
  "block.minecraft.crimson_pressure_plate": "pleata-brùthaidh crò-dhearg",
  "block.minecraft.warped_pressure_plate": "pleata-brùthaidh saobh",
  "block.minecraft.polished_blackstone_pressure_plate": "pleata-brùthaidh dubh-chloiche lìomhta",
  "block.minecraft.redstone_ore": "clach-redstone",
  "block.minecraft.redstone_torch": "lòchran redstone",
  "block.minecraft.snow": "sneachd",
  "block.minecraft.ice": "deigh",
  "block.minecraft.snow_block": "bloca sneachda",
  "block.minecraft.cactus": "cactas",
  "block.minecraft.clay": "criadh",
  "block.minecraft.jukebox": "inneal-chlàr",
  "block.minecraft.oak_fence": "feansa daraich",
  "block.minecraft.spruce_fence": "feansa giuthais",
  "block.minecraft.birch_fence": "feansa beithe",
  "block.minecraft.jungle_fence": "feansa dlùth-choille",
  "block.minecraft.acacia_fence": "feansa sitta",
  "block.minecraft.dark_oak_fence": "feansa daraich dhuirch",
  "block.minecraft.crimson_fence": "feansa crò-dhearg",
  "block.minecraft.warped_fence": "feansa saobh",
  "block.minecraft.pumpkin": "peapag",
  "block.minecraft.carved_pumpkin": "peapag shnaidhte",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "gainmheach anama",
  "block.minecraft.soul_soil": "ùir anama",
  "block.minecraft.basalt": "basalt",
  "block.minecraft.polished_basalt": "basalt lìomhta",
  "block.minecraft.soul_torch": "lòchran anama",
  "block.minecraft.glowstone": "clach-dhealraidh",
  "block.minecraft.jack_o_lantern": "peapag shamhna",
  "block.minecraft.oak_trapdoor": "doras-leigeil daraich",
  "block.minecraft.spruce_trapdoor": "doras-leigeil giuthais",
  "block.minecraft.birch_trapdoor": "doras-leigeil beithe",
  "block.minecraft.jungle_trapdoor": "doras-leigeil dlùth-choille",
  "block.minecraft.acacia_trapdoor": "doras-leigeil sitta",
  "block.minecraft.dark_oak_trapdoor": "doras-leigeil daraich dhuirch",
  "block.minecraft.crimson_trapdoor": "doras-leigeil crò-dhearg",
  "block.minecraft.warped_trapdoor": "doras-leigeil saobh",
  "block.minecraft.infested_stone": "clach fhiolanach",
  "block.minecraft.infested_cobblestone": "clach-chàsaidh fhiolanach",
  "block.minecraft.infested_stone_bricks": "breigichean fiolanach cloiche",
  "block.minecraft.infested_mossy_stone_bricks": "breigichean fiolanach cloiche còinneachail",
  "block.minecraft.infested_cracked_stone_bricks": "breigichean fiolanach sgagach cloiche",
  "block.minecraft.infested_chiseled_stone_bricks": "breigichean fiolanach cloiche gilbichte",
  "block.minecraft.stone_bricks": "breigichean cloiche",
  "block.minecraft.mossy_stone_bricks": "breigichean cloiche còinneachail",
  "block.minecraft.cracked_stone_bricks": "breigichean sgagach cloiche",
  "block.minecraft.chiseled_stone_bricks": "breigichean cloiche gilbichte",
  "block.minecraft.brown_mushroom_block": "bloca balgain-bhuachair dhuinn",
  "block.minecraft.red_mushroom_block": "bloca balgain-bhuachair dheirg",
  "block.minecraft.mushroom_stem": "gas balgain-bhuachair",
  "block.minecraft.iron_bars": "bàraichean iarainn",
  "block.minecraft.chain": "slabhraidh",
  "block.minecraft.glass_pane": "leòsan glainne",
  "block.minecraft.melon": "meal-bhuc",
  "block.minecraft.vine": "fìonain",
  "block.minecraft.oak_fence_gate": "geata feansa daraich",
  "block.minecraft.spruce_fence_gate": "geata feansa giuthais",
  "block.minecraft.birch_fence_gate": "geata feansa beithe",
  "block.minecraft.jungle_fence_gate": "geata feansa dlùth-choille",
  "block.minecraft.acacia_fence_gate": "geata feansa sitta",
  "block.minecraft.dark_oak_fence_gate": "geata feansa daraich dhuirch",
  "block.minecraft.crimson_fence_gate": "geata feansa crò-dhearg",
  "block.minecraft.warped_fence_gate": "geata feansa saobh",
  "block.minecraft.brick_stairs": "staidhre bhreigichean",
  "block.minecraft.stone_brick_stairs": "staidhre bhreigichean cloiche",
  "block.minecraft.mycelium": "mycelium",
  "block.minecraft.lily_pad": "duilleag-bhàthte",
  "block.minecraft.nether_bricks": "breigichean nether",
  "block.minecraft.cracked_nether_bricks": "breigichean nether sgagach",
  "block.minecraft.chiseled_nether_bricks": "breigichean nether gilbichte",
  "block.minecraft.nether_brick_fence": "feansa bhreigichean nether",
  "block.minecraft.nether_brick_stairs": "staidhre bhreigichean nether",
  "block.minecraft.enchanting_table": "geas-bhòrd",
  "block.minecraft.end_portal_frame": "frèama portal end",
  "block.minecraft.end_stone": "clach end",
  "block.minecraft.end_stone_bricks": "breigichean cloiche end",
  "block.minecraft.dragon_egg": "ugh dràgoin",
  "block.minecraft.redstone_lamp": "lampa redstone",
  "block.minecraft.sandstone_stairs": "staidhre cloiche-gainmhich",
  "block.minecraft.emerald_ore": "clach-smàraige",
  "block.minecraft.ender_chest": "ciste ender",
  "block.minecraft.tripwire_hook": "cromag uèir-ribe",
  "block.minecraft.emerald_block": "bloca smàraige",
  "block.minecraft.spruce_stairs": "staidhre giuthais",
  "block.minecraft.birch_stairs": "staidhre beithe",
  "block.minecraft.jungle_stairs": "staidhre dlùth-choille",
  "block.minecraft.crimson_stairs": "staidhre chrò-dhearg",
  "block.minecraft.warped_stairs": "staidhre shaobh",
  "block.minecraft.command_block": "bloca-àithne",
  "block.minecraft.beacon": "leus",
  "block.minecraft.cobblestone_wall": "balla cloiche-càsaidh",
  "block.minecraft.mossy_cobblestone_wall": "balla cloiche-càsaidh còinneachail",
  "block.minecraft.brick_wall": "balla bhreigichean",
  "block.minecraft.prismarine_wall": "balla priosaim-mhara",
  "block.minecraft.red_sandstone_wall": "balla cloiche-gainmhich ruaidhe",
  "block.minecraft.mossy_stone_brick_wall": "balla bhreigichean cloiche còinneachail",
  "block.minecraft.granite_wall": "balla gaireil",
  "block.minecraft.stone_brick_wall": "balla bhreigichean-cloiche",
  "block.minecraft.nether_brick_wall": "balla bhreigichean nether",
  "block.minecraft.andesite_wall": "balla andasait",
  "block.minecraft.red_nether_brick_wall": "balla bhreigichean ruadha nether",
  "block.minecraft.sandstone_wall": "balla cloiche-gainmhich",
  "block.minecraft.end_stone_brick_wall": "balla bhreigichean cloiche end",
  "block.minecraft.diorite_wall": "balla dìorait",
  "block.minecraft.blackstone_wall": "balla dubh-chloiche",
  "block.minecraft.polished_blackstone_wall": "balla dubh-chloiche lìomhta",
  "block.minecraft.polished_blackstone_brick_wall": "balla bhreigichean dubh-chloiche lìomhta",
  "block.minecraft.stone_button": "putan cloiche",
  "block.minecraft.oak_button": "putan daraich",
  "block.minecraft.spruce_button": "putan giuthais",
  "block.minecraft.birch_button": "putan beithe",
  "block.minecraft.jungle_button": "putan dlùth-choille",
  "block.minecraft.acacia_button": "putan sitta",
  "block.minecraft.dark_oak_button": "putan daraich dhuirch",
  "block.minecraft.crimson_button": "putan crò-dhearg",
  "block.minecraft.warped_button": "putan saobh",
  "block.minecraft.polished_blackstone_button": "putan dubh-chloiche lìomhta",
  "block.minecraft.anvil": "innean",
  "block.minecraft.chipped_anvil": "innean beàrnach",
  "block.minecraft.damaged_anvil": "innean millte",
  "block.minecraft.trapped_chest": "ciste le ribe",
  "block.minecraft.light_weighted_pressure_plate": "pleata-brùthaidh le cuideam aotrom",
  "block.minecraft.heavy_weighted_pressure_plate": "pleata-brùthaidh le cuideam trom",
  "block.minecraft.daylight_detector": "lorgaire solais",
  "block.minecraft.redstone_block": "bloca redstone",
  "block.minecraft.nether_quartz_ore": "clach-eiteige nether",
  "block.minecraft.hopper": "drabhailt",
  "block.minecraft.chiseled_quartz_block": "bloca eiteige gilbichte",
  "block.minecraft.quartz_block": "bloca eiteige",
  "block.minecraft.quartz_bricks": "breigichean eiteige",
  "block.minecraft.quartz_pillar": "colbh eiteige",
  "block.minecraft.quartz_stairs": "staidhre eiteige",
  "block.minecraft.activator_rail": "rèile-gnìomhachaidh",
  "block.minecraft.dropper": "bloca leigeil às",
  "block.minecraft.white_terracotta": "terracotta geal",
  "block.minecraft.orange_terracotta": "terracotta orains",
  "block.minecraft.magenta_terracotta": "terracotta maidèanta",
  "block.minecraft.light_blue_terracotta": "terracotta bàn-ghorm",
  "block.minecraft.yellow_terracotta": "terracotta buidhe",
  "block.minecraft.lime_terracotta": "terracotta bàn-uaine",
  "block.minecraft.pink_terracotta": "terracotta bàn-dearg",
  "block.minecraft.gray_terracotta": "terracotta glas",
  "block.minecraft.light_gray_terracotta": "terracotta liath",
  "block.minecraft.cyan_terracotta": "terracotta saidhean",
  "block.minecraft.purple_terracotta": "terracotta purpaidh",
  "block.minecraft.blue_terracotta": "terracotta gorm",
  "block.minecraft.brown_terracotta": "terracotta donn",
  "block.minecraft.green_terracotta": "terracotta uaine",
  "block.minecraft.red_terracotta": "terracotta dearg",
  "block.minecraft.black_terracotta": "terracotta dubh",
  "block.minecraft.barrier": "bacadh",
  "block.minecraft.iron_trapdoor": "doras-leigeil iarainn",
  "block.minecraft.hay_block": "bèile feòir",
  "block.minecraft.white_carpet": "brat-ùrlair geal",
  "block.minecraft.orange_carpet": "brat-ùrlair orains",
  "block.minecraft.magenta_carpet": "brat-ùrlair maidèanta",
  "block.minecraft.light_blue_carpet": "brat-ùrlair bàn-ghorm",
  "block.minecraft.yellow_carpet": "brat-ùrlair buidhe",
  "block.minecraft.lime_carpet": "brat-ùrlair bàn-uaine",
  "block.minecraft.pink_carpet": "brat-ùrlair bàn-dearg",
  "block.minecraft.gray_carpet": "brat-ùrlair glas",
  "block.minecraft.light_gray_carpet": "brat-ùrlair liath",
  "block.minecraft.cyan_carpet": "brat-ùrlair saidhean",
  "block.minecraft.purple_carpet": "brat-ùrlair purpaidh",
  "block.minecraft.blue_carpet": "brat-ùrlair gorm",
  "block.minecraft.brown_carpet": "brat-ùrlair donn",
  "block.minecraft.green_carpet": "brat-ùrlair uaine",
  "block.minecraft.red_carpet": "brat-ùrlair dearg",
  "block.minecraft.black_carpet": "brat-ùrlair dubh",
  "block.minecraft.terracotta": "terracotta",
  "block.minecraft.coal_block": "bloca guail",
  "block.minecraft.packed_ice": "deigh dhlùth",
  "block.minecraft.acacia_stairs": "staidhre sitta",
  "block.minecraft.dark_oak_stairs": "staidhre daraich dhuirch",
  "block.minecraft.slime_block": "bloca eabair",
  "block.minecraft.grass_path": "staran feòir",
  "block.minecraft.sunflower": "neòinean-grèine",
  "block.minecraft.lilac": "liath-ghorm",
  "block.minecraft.rose_bush": "preas nan ròs",
  "block.minecraft.peony": "meacan-easa",
  "block.minecraft.tall_grass": "feur fada",
  "block.minecraft.large_fern": "raineach mhòr",
  "block.minecraft.white_stained_glass": "glainne dhathte gheal",
  "block.minecraft.orange_stained_glass": "glainne dhathte orains",
  "block.minecraft.magenta_stained_glass": "glainne dhathte mhaidèanta",
  "block.minecraft.light_blue_stained_glass": "glainne dhathte bhàn-ghorm",
  "block.minecraft.yellow_stained_glass": "glainne dhathte bhuidhe",
  "block.minecraft.lime_stained_glass": "glainne dhathte bàn-uaine",
  "block.minecraft.pink_stained_glass": "glainne dhathte bhàn-dearg",
  "block.minecraft.gray_stained_glass": "glainne dhathte ghlas",
  "block.minecraft.light_gray_stained_glass": "glainne dhathte liath",
  "block.minecraft.cyan_stained_glass": "glainne dhathte shaidhean",
  "block.minecraft.purple_stained_glass": "glainne dhathte phurpaidh",
  "block.minecraft.blue_stained_glass": "glainne dhathte ghorm",
  "block.minecraft.brown_stained_glass": "glainne dhathte dhonn",
  "block.minecraft.green_stained_glass": "glainne dhathte uaine",
  "block.minecraft.red_stained_glass": "glainne dhathte dhearg",
  "block.minecraft.black_stained_glass": "glainne dhathte dhubh",
  "block.minecraft.white_stained_glass_pane": "leòsan glainne geal",
  "block.minecraft.orange_stained_glass_pane": "leòsan glainne orains",
  "block.minecraft.magenta_stained_glass_pane": "leòsan glainne maidèanta",
  "block.minecraft.light_blue_stained_glass_pane": "leòsan glainne bàn-ghorm",
  "block.minecraft.yellow_stained_glass_pane": "leòsan glainne buidhe",
  "block.minecraft.lime_stained_glass_pane": "leòsan glainne bàn-uaine",
  "block.minecraft.pink_stained_glass_pane": "leòsan glainne bàn-dearg",
  "block.minecraft.gray_stained_glass_pane": "leòsan glainne glas",
  "block.minecraft.light_gray_stained_glass_pane": "leòsan glainne liath",
  "block.minecraft.cyan_stained_glass_pane": "leòsan glainne saidhean",
  "block.minecraft.purple_stained_glass_pane": "leòsan glainne purpaidh",
  "block.minecraft.blue_stained_glass_pane": "leòsan glainne gorm",
  "block.minecraft.brown_stained_glass_pane": "leòsan glainne donn",
  "block.minecraft.green_stained_glass_pane": "leòsan glainne uaine",
  "block.minecraft.red_stained_glass_pane": "leòsan glainne dearg",
  "block.minecraft.black_stained_glass_pane": "leòsan glainne dubh",
  "block.minecraft.prismarine": "priosam-mara",
  "block.minecraft.prismarine_bricks": "breigichean priosaim-mhara",
  "block.minecraft.dark_prismarine": "priosam-mara dorcha",
  "block.minecraft.prismarine_stairs": "staidhre priosaim-mhara",
  "block.minecraft.prismarine_brick_stairs": "staidhre bhreigichean priosaim-mhara",
  "block.minecraft.dark_prismarine_stairs": "staidhre priosaim-mhara dhuirch",
  "block.minecraft.sea_lantern": "lòchran-mara",
  "block.minecraft.red_sandstone": "clach-ghainmhich ruadh",
  "block.minecraft.chiseled_red_sandstone": "clach-ghainmhich ruadh ghilbichte",
  "block.minecraft.cut_red_sandstone": "clach-ghainmhich ruadh gheàrrte",
  "block.minecraft.red_sandstone_stairs": "staidhre cloiche-gainmhich ruaidh",
  "block.minecraft.repeating_command_block": "bloca-àithne ath-dhèanaimh",
  "block.minecraft.chain_command_block": "bloca àitheantan sreatha",
  "block.minecraft.magma_block": "bloca magma",
  "block.minecraft.nether_wart_block": "bloca lusa nether",
  "block.minecraft.warped_wart_block": "bloca lusa shaoibh",
  "block.minecraft.red_nether_bricks": "breigichean ruadha nether",
  "block.minecraft.bone_block": "bloca cnàmha",
  "block.minecraft.structure_void": "fànas structair",
  "block.minecraft.observer": "coimheadaiche",
  "block.minecraft.shulker_box": "bogsa shulker",
  "block.minecraft.white_shulker_box": "bogsa shulker geal",
  "block.minecraft.orange_shulker_box": "bogsa shulker orains",
  "block.minecraft.magenta_shulker_box": "bogsa shulker maidèanta",
  "block.minecraft.light_blue_shulker_box": "bogsa shulker bàn-ghorm",
  "block.minecraft.yellow_shulker_box": "bogsa shulker buidhe",
  "block.minecraft.lime_shulker_box": "bogsa shulker bàn-uaine",
  "block.minecraft.pink_shulker_box": "bogsa shulker bàn-dearg",
  "block.minecraft.gray_shulker_box": "bogsa shulker glas",
  "block.minecraft.light_gray_shulker_box": "bogsa shulker liath",
  "block.minecraft.cyan_shulker_box": "bogsa shulker saidhean",
  "block.minecraft.purple_shulker_box": "bogsa shulker purpaidh",
  "block.minecraft.blue_shulker_box": "bogsa shulker gorm",
  "block.minecraft.brown_shulker_box": "bogsa shulker donn",
  "block.minecraft.green_shulker_box": "bogsa shulker uaine",
  "block.minecraft.red_shulker_box": "bogsa shulker dearg",
  "block.minecraft.black_shulker_box": "bogsa shulker dubh",
  "block.minecraft.white_glazed_terracotta": "terracotta gloinichte geal",
  "block.minecraft.orange_glazed_terracotta": "terracotta gloinichte orains",
  "block.minecraft.magenta_glazed_terracotta": "terracotta gloinichte maidèanta",
  "block.minecraft.light_blue_glazed_terracotta": "terracotta gloinichte bàn-ghorm",
  "block.minecraft.yellow_glazed_terracotta": "terracotta gloinichte buidhe",
  "block.minecraft.lime_glazed_terracotta": "terracotta gloinichte bàn-uaine",
  "block.minecraft.pink_glazed_terracotta": "terracotta gloinichte bàn-dearg",
  "block.minecraft.gray_glazed_terracotta": "terracotta gloinichte glas",
  "block.minecraft.light_gray_glazed_terracotta": "terracotta gloinichte liath",
  "block.minecraft.cyan_glazed_terracotta": "terracotta gloinichte saidhean",
  "block.minecraft.purple_glazed_terracotta": "terracotta gloinichte purpaidh",
  "block.minecraft.blue_glazed_terracotta": "terracotta gloinichte gorm",
  "block.minecraft.brown_glazed_terracotta": "terracotta gloinichte donn",
  "block.minecraft.green_glazed_terracotta": "terracotta gloinichte uaine",
  "block.minecraft.red_glazed_terracotta": "terracotta gloinichte dearg",
  "block.minecraft.black_glazed_terracotta": "terracotta gloinichte dubh",
  "block.minecraft.white_concrete": "concrait gheal",
  "block.minecraft.orange_concrete": "concrait orains",
  "block.minecraft.magenta_concrete": "concrait mhaidèanta",
  "block.minecraft.light_blue_concrete": "concrait bhàn-ghorm",
  "block.minecraft.yellow_concrete": "concrait bhuidhe",
  "block.minecraft.lime_concrete": "concrait bhàn-uaine",
  "block.minecraft.pink_concrete": "concrait bhàn-dearg",
  "block.minecraft.gray_concrete": "concrait ghlas",
  "block.minecraft.light_gray_concrete": "concrait liath",
  "block.minecraft.cyan_concrete": "concrait shaidhean",
  "block.minecraft.purple_concrete": "concrait phurpaidh",
  "block.minecraft.blue_concrete": "concrait ghorm",
  "block.minecraft.brown_concrete": "concrait dhonn",
  "block.minecraft.green_concrete": "concrait uaine",
  "block.minecraft.red_concrete": "concrait dhearg",
  "block.minecraft.black_concrete": "concrait dhubh",
  "block.minecraft.white_concrete_powder": "mìn-choncrait gheal",
  "block.minecraft.orange_concrete_powder": "mìn-choncrait orains",
  "block.minecraft.magenta_concrete_powder": "mìn-choncrait mhaidèanta",
  "block.minecraft.light_blue_concrete_powder": "mìn-choncrait bhàn-ghorm",
  "block.minecraft.yellow_concrete_powder": "mìn-choncrait bhuidhe",
  "block.minecraft.lime_concrete_powder": "mìn-choncrait bhàn-uaine",
  "block.minecraft.pink_concrete_powder": "mìn-choncrait bhàn-dearg",
  "block.minecraft.gray_concrete_powder": "mìn-choncrait ghlas",
  "block.minecraft.light_gray_concrete_powder": "mìn-choncrait liath",
  "block.minecraft.cyan_concrete_powder": "mìn-choncrait shaidhean",
  "block.minecraft.purple_concrete_powder": "mìn-choncrait phurpaidh",
  "block.minecraft.blue_concrete_powder": "mìn-choncrait ghorm",
  "block.minecraft.brown_concrete_powder": "mìn-choncrait dhonn",
  "block.minecraft.green_concrete_powder": "mìn-choncrait uaine",
  "block.minecraft.red_concrete_powder": "mìn-choncrait dhearg",
  "block.minecraft.black_concrete_powder": "mìn-choncrait dhubh",
  "block.minecraft.turtle_egg": "ugh turtair",
  "block.minecraft.dead_tube_coral_block": "bloca coireil-phìoba mhairbh",
  "block.minecraft.dead_brain_coral_block": "bloca coireil-eanchainne mhairbh",
  "block.minecraft.dead_bubble_coral_block": "bloca coireil-bhuilgein mhairbh",
  "block.minecraft.dead_fire_coral_block": "bloca coireil-teine mhairbh",
  "block.minecraft.dead_horn_coral_block": "bloca coireil-adhairc mhairbh",
  "block.minecraft.tube_coral_block": "bloca coireil-phìoba",
  "block.minecraft.brain_coral_block": "bloca coireil-eanchainne",
  "block.minecraft.bubble_coral_block": "bloca coireil-bhuilgein",
  "block.minecraft.fire_coral_block": "bloca coireil-teine",
  "block.minecraft.horn_coral_block": "bloca coireil-adhairc",
  "block.minecraft.tube_coral": "coireal-pìoba",
  "block.minecraft.brain_coral": "coireal-eanchainne",
  "block.minecraft.bubble_coral": "coireal-builgein",
  "block.minecraft.fire_coral": "coireal-teine",
  "block.minecraft.horn_coral": "coireal-adhairc",
  "block.minecraft.dead_brain_coral": "coireal-eanchainne marbh",
  "block.minecraft.dead_bubble_coral": "coireal-builgein marbh",
  "block.minecraft.dead_fire_coral": "coireal-teine marbh",
  "block.minecraft.dead_horn_coral": "coireal-adhairc marbh",
  "block.minecraft.dead_tube_coral": "coireal-pìoba marbh",
  "block.minecraft.tube_coral_fan": "sgàileag coireil-phìoba",
  "block.minecraft.brain_coral_fan": "sgàileag coireil-eanchainne",
  "block.minecraft.bubble_coral_fan": "sgàileag coireil-bhuilgein",
  "block.minecraft.fire_coral_fan": "sgàileag coireil-teine",
  "block.minecraft.horn_coral_fan": "sgàileag coireil-adhairc",
  "block.minecraft.dead_tube_coral_fan": "sgàileag coireil-phìoba mhairbh",
  "block.minecraft.dead_brain_coral_fan": "sgàileag coireil-eanchainne mhairbh",
  "block.minecraft.dead_bubble_coral_fan": "sgàileag coireil-bhuilgein mhairbh",
  "block.minecraft.dead_fire_coral_fan": "sgàileag coireil-teine mhairbh",
  "block.minecraft.dead_horn_coral_fan": "sgàileag coireil-adhairc mhairbh",
  "block.minecraft.blue_ice": "deigh ghorm",
  "block.minecraft.conduit": "seòl-phìob",
  "block.minecraft.polished_granite_stairs": "staidhre gaireil lìomhta",
  "block.minecraft.smooth_red_sandstone_stairs": "staidhre cloiche-gainmhich ruaidhe rèidhe",
  "block.minecraft.mossy_stone_brick_stairs": "staidhre bhreigichean cloiche còinneachail",
  "block.minecraft.polished_diorite_stairs": "staidhre dìorait lìomhta",
  "block.minecraft.mossy_cobblestone_stairs": "staidhre cloiche-càsaidh còinneachail",
  "block.minecraft.end_stone_brick_stairs": "staidhre bhreigichean cloiche end",
  "block.minecraft.stone_stairs": "staidhre cloiche",
  "block.minecraft.smooth_sandstone_stairs": "staidhre cloiche-gainmhich rèidhe",
  "block.minecraft.smooth_quartz_stairs": "staidhre eiteige rèidhe",
  "block.minecraft.granite_stairs": "staidhre gaireil",
  "block.minecraft.andesite_stairs": "staidhre andasait",
  "block.minecraft.red_nether_brick_stairs": "staidhre bhreigichean ruadha nether",
  "block.minecraft.polished_andesite_stairs": "staidhre andasait lìomhta",
  "block.minecraft.diorite_stairs": "staidhre dìorait",
  "block.minecraft.polished_granite_slab": "leac gaireil lìomhta",
  "block.minecraft.smooth_red_sandstone_slab": "leac cloiche-gainmhich ruaidhe rèidhe",
  "block.minecraft.mossy_stone_brick_slab": "leac bhreigichean cloiche còinneachail",
  "block.minecraft.polished_diorite_slab": "leac dìorait lìomhta",
  "block.minecraft.mossy_cobblestone_slab": "leac cloiche-càsaidh còinneachail",
  "block.minecraft.end_stone_brick_slab": "leac bhreigichean cloiche end",
  "block.minecraft.smooth_sandstone_slab": "leac cloiche-gainmhich rèidhe",
  "block.minecraft.smooth_quartz_slab": "leac eiteige rèidhe",
  "block.minecraft.granite_slab": "leac gaireil",
  "block.minecraft.andesite_slab": "leac andasait",
  "block.minecraft.red_nether_brick_slab": "leac bhreigichean ruadha nether",
  "block.minecraft.polished_andesite_slab": "leac andasait lìomhta",
  "block.minecraft.diorite_slab": "leac dìorait",
  "block.minecraft.scaffolding": "sgafallachd",
  "block.minecraft.iron_door": "doras iarainn",
  "block.minecraft.oak_door": "doras daraich",
  "block.minecraft.spruce_door": "doras giuthais",
  "block.minecraft.birch_door": "doras beithe",
  "block.minecraft.jungle_door": "doras dlùth-choille",
  "block.minecraft.acacia_door": "doras sitta",
  "block.minecraft.dark_oak_door": "doras daraich dhuirch",
  "block.minecraft.crimson_door": "doras crò-dhearg",
  "block.minecraft.warped_door": "doras saobh",
  "block.minecraft.repeater": "ath-chraoladair redstone",
  "block.minecraft.comparator": "inneal-coimeis redstone",
  "block.minecraft.structure_block": "bloca structair",
  "block.minecraft.jigsaw": "bloca mhìrean-measgte",
  "item.minecraft.turtle_helmet": "cochall turtair□□air ceann:□+2 armachd",
  "item.minecraft.scute": "lann turtair",
  "item.minecraft.iron_shovel": "sluasaid iarainn□□anns a' phrìomh làimh:□+3.5 dochann ionnsaighe□-3 luaths ionnsaighe",
  "item.minecraft.iron_pickaxe": "piocaid iarainn□□anns a' phrìomh làimh:□+3 dochann ionnsaighe□-2.8 luaths ionnsaighe",
  "item.minecraft.iron_axe": "tuagh iarainn□□anns a' phrìomh làimh:□+8 dochann ionnsaighe□-3.1 luaths ionnsaighe",
  "item.minecraft.flint_and_steel": "clach-theine is stàilinn",
  "item.minecraft.apple": "ubhal",
  "item.minecraft.bow": "bogha",
  "item.minecraft.arrow": "saighead",
  "item.minecraft.coal": "gual",
  "item.minecraft.charcoal": "gual-fhiodha",
  "item.minecraft.diamond": "daoimean",
  "item.minecraft.iron_ingot": "unga iarainn",
  "item.minecraft.gold_ingot": "unga òir",
  "item.minecraft.netherite_ingot": "unga netherit",
  "item.minecraft.netherite_scrap": "criomag netherit",
  "item.minecraft.iron_sword": "claidheamh iarainn□□anns a' phrìomh làimh:□+5 dochann ionnsaighe□-2.4 luaths ionnsaighe",
  "item.minecraft.wooden_sword": "claidheamh fiodha□□anns a' phrìomh làimh:□+3 dochann ionnsaighe□-2.4 luaths ionnsaighe",
  "item.minecraft.wooden_shovel": "sluasaid fiodha□□anns a' phrìomh làimh:□+1.5 dochann ionnsaighe□-3 luaths ionnsaighe",
  "item.minecraft.wooden_pickaxe": "piocaid fiodha□□anns a' phrìomh làimh:□+1 dochann ionnsaighe□-2.8 luaths ionnsaighe",
  "item.minecraft.wooden_axe": "tuagh fiodha□□anns a' phrìomh làimh:□+6 dochann ionnsaighe□-3.2 luaths ionnsaighe",
  "item.minecraft.stone_sword": "claidheamh cloiche□□anns a' phrìomh làimh:□+4 dochann ionnsaighe□-2.4 luaths ionnsaighe",
  "item.minecraft.stone_shovel": "sluasaid cloiche□□anns a' phrìomh làimh:□+2.5 dochann ionnsaighe□-3 luaths ionnsaighe",
  "item.minecraft.stone_pickaxe": "piocaid cloiche□□anns a' phrìomh làimh:□+2 dochann ionnsaighe□-2.8 luaths ionnsaighe",
  "item.minecraft.stone_axe": "tuagh cloiche□□anns a' phrìomh làimh:□+8 dochann ionnsaighe□-3.2 luaths ionnsaighe",
  "item.minecraft.diamond_sword": "claidheamh daoimein□□anns a' phrìomh làimh:□+6 dochann ionnsaighe□-2.4 luaths ionnsaighe",
  "item.minecraft.diamond_shovel": "sluasaid daoimein□□anns a' phrìomh làimh:□+4.5 dochann ionnsaighe□-3 luaths ionnsaighe",
  "item.minecraft.diamond_pickaxe": "piocaid daoimein□□anns a' phrìomh làimh:□+4 dochann ionnsaighe□-2.8 luaths ionnsaighe",
  "item.minecraft.diamond_axe": "tuagh daoimein□□anns a' phrìomh làimh:□+8 dochann ionnsaighe□-3 luaths ionnsaighe",
  "item.minecraft.stick": "bata",
  "item.minecraft.bowl": "bobhla",
  "item.minecraft.mushroom_stew": "stiubha balgain-bhuachair",
  "item.minecraft.golden_sword": "claidheamh òir□□anns a' phrìomh làimh:□+3 dochann ionnsaighe□-2.4 luaths ionnsaighe",
  "item.minecraft.golden_shovel": "sluasaid òir□□anns a' phrìomh làimh:□+1.5 dochann ionnsaighe□-3 luaths ionnsaighe",
  "item.minecraft.golden_pickaxe": "piocaid òir□□anns a' phrìomh làimh:□+1 dochann ionnsaighe□-2.8 luaths ionnsaighe",
  "item.minecraft.golden_axe": "tuagh òir□□anns a' phrìomh làimh:□+6 dochann ionnsaighe□-3 luaths ionnsaighe",
  "item.minecraft.netherite_sword": "claidheamh netherit□□anns a' phrìomh làimh:□+7 dochann ionnsaighe□-2.4 luaths ionnsaighe",
  "item.minecraft.netherite_shovel": "sluasaid netherit□□anns a' phrìomh làimh:□+5.5 dochann ionnsaighe□-3 luaths ionnsaighe",
  "item.minecraft.netherite_pickaxe": "piocaid netherit□□anns a' phrìomh làimh:□+5 dochann ionnsaighe□-2.8 luaths ionnsaighe",
  "item.minecraft.netherite_axe": "tuagh netherit□□anns a' phrìomh làimh:□+9 dochann ionnsaighe□-3 luaths ionnsaighe",
  "item.minecraft.string": "sreang",
  "item.minecraft.feather": "ite",
  "item.minecraft.gunpowder": "fùdar-gunna",
  "item.minecraft.wooden_hoe": "tobha fiodha□□anns a' phrìomh làimh:□-3 luaths ionnsaighe",
  "item.minecraft.stone_hoe": "tobha cloiche□□anns a' phrìomh làimh:□-2 luaths ionnsaighe",
  "item.minecraft.iron_hoe": "tobha iarainn□□anns a' phrìomh làimh:□-1 luaths ionnsaighe",
  "item.minecraft.diamond_hoe": "tobha daoimein□□anns a' phrìomh làimh:",
  "item.minecraft.golden_hoe": "tobha òir□□anns a' phrìomh làimh:□-3 luaths ionnsaighe",
  "item.minecraft.netherite_hoe": "tobha netherit□□anns a' phrìomh làimh:",
  "item.minecraft.wheat_seeds": "sìl cruithneachd",
  "item.minecraft.wheat": "cruithneachd",
  "item.minecraft.bread": "aran",
  "item.minecraft.leather_helmet": "currac leathair□□air ceann:□+1 armachd",
  "item.minecraft.leather_chestplate": "lèine leathair□□mu chom:□+3 armachd",
  "item.minecraft.leather_leggings": "briogais leathair□□mu chasan:□+2 armachd",
  "item.minecraft.leather_boots": "bòtannan leathair□□mu throighean:□+1 armachd",
  "item.minecraft.chainmail_helmet": "clogaid mhàilleach□□air ceann:□+2 armachd",
  "item.minecraft.chainmail_chestplate": "lùireach mhàilleach□□mu chom:□+5 armachd",
  "item.minecraft.chainmail_leggings": "briogais mhàilleach□□mu chasan:□+4 armachd",
  "item.minecraft.chainmail_boots": "bòtannan màilleach□□mu throighean:□+1 armachd",
  "item.minecraft.iron_helmet": "clogaid iarainn□□air ceann:□+2 armachd",
  "item.minecraft.iron_chestplate": "lùireach iarainn□□mu chom:□+6 armachd",
  "item.minecraft.iron_leggings": "briogais iarainn□□mu chasan:□+5 armachd",
  "item.minecraft.iron_boots": "bòtannan iarainn□□mu throighean:□+2 armachd",
  "item.minecraft.diamond_helmet": "clogaid daoimein□□air ceann:□+3 armachd□+2 cruas na h-armachd",
  "item.minecraft.diamond_chestplate": "lùireach daoimein□□mu chom:□+8 armachd□+2 cruas na h-armachd",
  "item.minecraft.diamond_leggings": "briogais daoimein□□mu chasan:□+6 armachd□+2 cruas na h-armachd",
  "item.minecraft.diamond_boots": "bòtannan daoimein□□mu throighean:□+3 armachd□+2 cruas na h-armachd",
  "item.minecraft.golden_helmet": "clogaid òir□□air ceann:□+2 armachd",
  "item.minecraft.golden_chestplate": "lùireach òir□□mu chom:□+5 armachd",
  "item.minecraft.golden_leggings": "briogais òir□□mu chasan:□+3 armachd",
  "item.minecraft.golden_boots": "bòtannan òir□□mu throighean:□+1 armachd",
  "item.minecraft.netherite_helmet": "clogaid netherit□□air ceann:□+3 armachd□+3 cruas na h-armachd□+1 seasamh an aghaidh sraonaidh",
  "item.minecraft.netherite_chestplate": "lùireach netherit□□mu chom:□+8 armachd□+3 cruas na h-armachd□+1 seasamh an aghaidh sraonaidh",
  "item.minecraft.netherite_leggings": "briogais netherit□□mu chasan:□+6 armachd□+3 cruas na h-armachd□+1 seasamh an aghaidh sraonaidh",
  "item.minecraft.netherite_boots": "bòtannan netherit□□mu throighean:□+3 armachd□+3 cruas na h-armachd□+1 seasamh an aghaidh sraonaidh",
  "item.minecraft.flint": "clach-theine",
  "item.minecraft.porkchop": "muicfheoil amh",
  "item.minecraft.cooked_porkchop": "muicfheoil ròiste",
  "item.minecraft.painting": "dealbh",
  "item.minecraft.golden_apple": "ubhal òir",
  "item.minecraft.enchanted_golden_apple": "ubhal òir fo gheas",
  "block.minecraft.oak_sign": "soidhne daraich",
  "block.minecraft.spruce_sign": "soidhne giuthais",
  "block.minecraft.birch_sign": "soidhne beithe",
  "block.minecraft.jungle_sign": "soidhne dlùth-choille",
  "block.minecraft.acacia_sign": "soidhne sitta",
  "block.minecraft.dark_oak_sign": "soidhne daraich dhuirch",
  "block.minecraft.crimson_sign": "soidhne chrò-dhearg",
  "block.minecraft.warped_sign": "soidhne shaobh",
  "item.minecraft.bucket": "bucaid",
  "item.minecraft.water_bucket": "bucaid uisge",
  "item.minecraft.lava_bucket": "bucaid làbha",
  "item.minecraft.minecart": "cairt-mhèinnearachd",
  "item.minecraft.saddle": "dìollaid",
  "item.minecraft.redstone": "duslach redstone",
  "item.minecraft.snowball": "ball-sneachda",
  "item.minecraft.oak_boat": "bàta daraich",
  "item.minecraft.leather": "leathar",
  "item.minecraft.milk_bucket": "bucaid bainne",
  "item.minecraft.pufferfish_bucket": "iasg-sèididh ann am bucaid",
  "item.minecraft.salmon_bucket": "bradan ann am bucaid",
  "item.minecraft.cod_bucket": "trosg ann am bucaid",
  "item.minecraft.tropical_fish_bucket": "iasg tropaigeach ann am bucaid",
  "item.minecraft.brick": "breige",
  "item.minecraft.clay_ball": "ball criadha",
  "block.minecraft.dried_kelp_block": "bloca ceilpe thiormaichte",
  "item.minecraft.paper": "pàipear",
  "item.minecraft.book": "leabhar",
  "item.minecraft.slime_ball": "ball eabair",
  "item.minecraft.chest_minecart": "cairt-mhèinnearachd le ciste",
  "item.minecraft.furnace_minecart": "cairt-mhèinnearachd le fùirneis",
  "item.minecraft.egg": "ugh",
  "item.minecraft.compass": "combaist",
  "item.minecraft.fishing_rod": "slat-iasgaich",
  "item.minecraft.clock": "uaireadair",
  "item.minecraft.glowstone_dust": "duslach cloiche-dealraidh",
  "item.minecraft.cod": "trosg amh",
  "item.minecraft.salmon": "bradan amh",
  "item.minecraft.tropical_fish": "iasg tropaigeach",
  "item.minecraft.pufferfish": "iasg-sèididh",
  "item.minecraft.cooked_cod": "trosg ròiste",
  "item.minecraft.cooked_salmon": "bradan ròiste",
  "item.minecraft.ink_sac": "poca-ince",
  "item.minecraft.red_dye": "dath dearg",
  "item.minecraft.green_dye": "liath uaine",
  "item.minecraft.cocoa_beans": "cnòthan-còco",
  "item.minecraft.lapis_lazuli": "clach-chopair",
  "item.minecraft.purple_dye": "dath purpaidh",
  "item.minecraft.cyan_dye": "dath saidhean",
  "item.minecraft.light_gray_dye": "dath liath",
  "item.minecraft.gray_dye": "dath glas",
  "item.minecraft.pink_dye": "dath bàn-dearg",
  "item.minecraft.lime_dye": "dath bàn-uaine",
  "item.minecraft.yellow_dye": "dath buidhe",
  "item.minecraft.light_blue_dye": "dath bàn-ghorm",
  "item.minecraft.magenta_dye": "dath maidèanta",
  "item.minecraft.orange_dye": "dath orains",
  "item.minecraft.bone_meal": "min-chnàmha",
  "item.minecraft.blue_dye": "dath gorm",
  "item.minecraft.brown_dye": "dath donn",
  "item.minecraft.black_dye": "dath dubh",
  "item.minecraft.white_dye": "dath geal",
  "item.minecraft.bone": "cnàimh",
  "item.minecraft.sugar": "siùcar",
  "block.minecraft.cake": "cèic",
  "block.minecraft.white_bed": "leabaidh gheal",
  "block.minecraft.orange_bed": "leabaidh orains",
  "block.minecraft.magenta_bed": "leabaidh mhaidèanta",
  "block.minecraft.light_blue_bed": "leabaidh bhàn-ghorm",
  "block.minecraft.yellow_bed": "leabaidh bhuidhe",
  "block.minecraft.lime_bed": "leabaidh bhàn-uaine",
  "block.minecraft.pink_bed": "leabaidh bhàn-dearg",
  "block.minecraft.gray_bed": "leabaidh ghlas",
  "block.minecraft.light_gray_bed": "leabaidh liath",
  "block.minecraft.cyan_bed": "leabaidh shaidhean",
  "block.minecraft.purple_bed": "leabaidh phurpaidh",
  "block.minecraft.blue_bed": "leabaidh ghorm",
  "block.minecraft.brown_bed": "leabaidh dhonn",
  "block.minecraft.green_bed": "leabaidh uaine",
  "block.minecraft.red_bed": "leabaidh dhearg",
  "block.minecraft.black_bed": "leabaidh dhubh",
  "item.minecraft.cookie": "briosgaid",
  "item.minecraft.filled_map": "mapa□#0",
  "item.minecraft.shears": "deamhas",
  "item.minecraft.melon_slice": "sliseag meal-bhuic",
  "item.minecraft.dried_kelp": "ceilp thioramaichte",
  "item.minecraft.pumpkin_seeds": "sìl peapaige",
  "item.minecraft.melon_seeds": "sìl meal-bhuic",
  "item.minecraft.beef": "mairtfheoil amh",
  "item.minecraft.cooked_beef": "mairtfheoil ròiste",
  "item.minecraft.chicken": "cearc amh",
  "item.minecraft.cooked_chicken": "cearc ròiste",
  "item.minecraft.rotten_flesh": "feòil lobhta",
  "item.minecraft.ender_pearl": "neamhnaid ender",
  "item.minecraft.blaze_rod": "slat leòis",
  "item.minecraft.ghast_tear": "deur ghast",
  "item.minecraft.gold_nugget": "cnapan òir",
  "item.minecraft.nether_wart": "lus nether",
  "item.minecraft.potion": "deoch nach gabh dèanamh le ceàrd□gun bhuadh",
  "item.minecraft.glass_bottle": "searrag glainne",
  "item.minecraft.spider_eye": "sùil damhain-allaidh",
  "item.minecraft.fermented_spider_eye": "sùil damhain-allaidh bracha",
  "item.minecraft.blaze_powder": "fùdar leòis",
  "item.minecraft.magma_cream": "cè magma",
  "block.minecraft.brewing_stand": "inneal-grùdaireachd",
  "block.minecraft.cauldron": "coire",
  "item.minecraft.ender_eye": "sùil ender",
  "item.minecraft.glistering_melon_slice": "sliseag meal-bhuic ghleansach",
  "item.minecraft.bat_spawn_egg": "ugh gintinn ialtaig",
  "item.minecraft.bee_spawn_egg": "ugh gintinn seillein",
  "item.minecraft.blaze_spawn_egg": "ugh gintinn leòis",
  "item.minecraft.cat_spawn_egg": "ugh gintinn cait",
  "item.minecraft.cave_spider_spawn_egg": "ugh gintinn damhain-allaidh uamha",
  "item.minecraft.chicken_spawn_egg": "ugh gintinn circe",
  "item.minecraft.cod_spawn_egg": "ugh gintinn truisg",
  "item.minecraft.cow_spawn_egg": "ugh gintinn bà",
  "item.minecraft.creeper_spawn_egg": "ugh gintinn creeper",
  "item.minecraft.dolphin_spawn_egg": "ugh gintinn leumadair",
  "item.minecraft.donkey_spawn_egg": "ugh ginntinn asail",
  "item.minecraft.drowned_spawn_egg": "ugh ginntinn bàithtich",
  "item.minecraft.elder_guardian_spawn_egg": "ugh gintinn seann-fhreiceadain",
  "item.minecraft.enderman_spawn_egg": "ugh gintinn enderman",
  "item.minecraft.endermite_spawn_egg": "ugh gintinn endermite",
  "item.minecraft.evoker_spawn_egg": "ugh gintinn tairmeir",
  "item.minecraft.fox_spawn_egg": "ugh gintinn sionnaich",
  "item.minecraft.ghast_spawn_egg": "ugh gintinn ghast",
  "item.minecraft.guardian_spawn_egg": "ugh gintinn freiceadain",
  "item.minecraft.hoglin_spawn_egg": "ugh gintinn hoglin",
  "item.minecraft.horse_spawn_egg": "ugh gintinn eich",
  "item.minecraft.husk_spawn_egg": "ugh gintinn mogail",
  "item.minecraft.llama_spawn_egg": "ugh gintinn llama",
  "item.minecraft.magma_cube_spawn_egg": "ugh gintinn ciùba-mhagma",
  "item.minecraft.mooshroom_spawn_egg": "ugh gintinn mooshroom",
  "item.minecraft.mule_spawn_egg": "ugh gintinn leth-asail",
  "item.minecraft.ocelot_spawn_egg": "ugh gintinn cait fhiadhaich",
  "item.minecraft.panda_spawn_egg": "ugh gintinn panda",
  "item.minecraft.parrot_spawn_egg": "ugh gintinn pearraid",
  "item.minecraft.phantom_spawn_egg": "ugh gintinn tannaisg",
  "item.minecraft.pig_spawn_egg": "ugh gintinn muice",
  "item.minecraft.piglin_spawn_egg": "ugh gintinn piglin",
  "item.minecraft.pillager_spawn_egg": "ugh gintinn spùinneadair",
  "item.minecraft.polar_bear_spawn_egg": "ugh gintinn mathain-bhàin",
  "item.minecraft.pufferfish_spawn_egg": "ugh gintinn èisg-shèididh",
  "item.minecraft.rabbit_spawn_egg": "ugh gintinn coineanaich",
  "item.minecraft.ravager_spawn_egg": "ugh gintinn creachadair",
  "item.minecraft.salmon_spawn_egg": "ugh gintinn bradain",
  "item.minecraft.sheep_spawn_egg": "ugh gintinn caorach",
  "item.minecraft.shulker_spawn_egg": "ugh gintinn shulker",
  "item.minecraft.silverfish_spawn_egg": "ugh gintinn fiolain-ghlais",
  "item.minecraft.skeleton_spawn_egg": "ugh gintinn cnàimhnich",
  "item.minecraft.skeleton_horse_spawn_egg": "ugh gintinn eich-chnàimhnich",
  "item.minecraft.slime_spawn_egg": "ugh gintinn eabair",
  "item.minecraft.spider_spawn_egg": "ugh gintinn damhain-allaidh",
  "item.minecraft.squid_spawn_egg": "ugh gintinn giobarnaich",
  "item.minecraft.stray_spawn_egg": "ugh gintinn conadail",
  "item.minecraft.strider_spawn_egg": "ugh gintinn ceumaiche",
  "item.minecraft.trader_llama_spawn_egg": "ugh gintinn llama marsanta",
  "item.minecraft.tropical_fish_spawn_egg": "ugh gintinn èisg thropaigich",
  "item.minecraft.turtle_spawn_egg": "ugh gintinn turtair",
  "item.minecraft.vex_spawn_egg": "ugh gintinn buaireadair",
  "item.minecraft.villager_spawn_egg": "ugh gintinn saoranaich",
  "item.minecraft.vindicator_spawn_egg": "ugh gintinn tagaire",
  "item.minecraft.wandering_trader_spawn_egg": "ugh gintinn marsanta allabanaich",
  "item.minecraft.witch_spawn_egg": "ugh gintinn bana-bhuidsiche",
  "item.minecraft.wither_skeleton_spawn_egg": "ugh gintinn wither-chnàimhnich",
  "item.minecraft.wolf_spawn_egg": "ugh gintinn madaidh-allaidh",
  "item.minecraft.zoglin_spawn_egg": "ugh gintinn zoglin",
  "item.minecraft.zombie_spawn_egg": "ugh gintinn cuirp-choisiche",
  "item.minecraft.zombie_horse_spawn_egg": "ugh gintinn cuirp-eich",
  "item.minecraft.zombie_villager_spawn_egg": "ugh gintinn corp-coisiche saoranaich",
  "item.minecraft.zombified_piglin_spawn_egg": "ugh gintinn piglin",
  "item.minecraft.experience_bottle": "searrag geasa",
  "item.minecraft.fire_charge": "bun teine",
  "item.minecraft.writable_book": "leabhar is cleit",
  "item.minecraft.written_book": "leabhar sgrìobhte",
  "item.minecraft.emerald": "smàrag",
  "item.minecraft.item_frame": "frèam",
  "block.minecraft.flower_pot": "poit-fhlùir",
  "item.minecraft.carrot": "curran",
  "item.minecraft.potato": "buntàta",
  "item.minecraft.baked_potato": "buntàta àmhainne",
  "item.minecraft.poisonous_potato": "buntàta puinnseanta",
  "item.minecraft.map": "mapa falamh",
  "item.minecraft.golden_carrot": "curran òir",
  "block.minecraft.skeleton_skull": "claigeann cnàimhnich",
  "block.minecraft.wither_skeleton_skull": "claigeann wither-chnàimhnich",
  "block.minecraft.player_head": "ceann cluicheadair",
  "block.minecraft.zombie_head": "ceann cuirp-choisiche",
  "block.minecraft.creeper_head": "ceann creeper",
  "block.minecraft.dragon_head": "ceann dràgoin",
  "item.minecraft.carrot_on_a_stick": "bata agus curran air",
  "item.minecraft.warped_fungus_on_a_stick": "fungas saobh air bata",
  "item.minecraft.nether_star": "rionnag nether",
  "item.minecraft.pumpkin_pie": "pàidh peapaige",
  "item.minecraft.firework_rocket": "rocaid cleasa-theine",
  "item.minecraft.firework_star": "rionnag cleasa-theine",
  "item.minecraft.enchanted_book": "leabhar fo gheas",
  "item.minecraft.nether_brick": "breige nether",
  "item.minecraft.quartz": "eiteag nether",
  "item.minecraft.tnt_minecart": "cairt-mhèinnearachd le tnt",
  "item.minecraft.hopper_minecart": "cairt-mhèinnearachd le drabhailt",
  "item.minecraft.prismarine_shard": "sgealb priosaim-mhara",
  "item.minecraft.prismarine_crystals": "criostalan priosaim-mhara",
  "item.minecraft.rabbit": "feòil-choineanaich amh",
  "item.minecraft.cooked_rabbit": "feòil-choineanaich ròiste",
  "item.minecraft.rabbit_stew": "stiubha coineanaich",
  "item.minecraft.rabbit_foot": "cas coineanaich",
  "item.minecraft.rabbit_hide": "bian coineanaich",
  "item.minecraft.armor_stand": "sorchan armachd",
  "item.minecraft.iron_horse_armor": "armachd eich iarainn",
  "item.minecraft.golden_horse_armor": "armachd eich òir",
  "item.minecraft.diamond_horse_armor": "armachd eich daoimein",
  "item.minecraft.leather_horse_armor": "armachd eich leathair",
  "item.minecraft.lead": "taod",
  "item.minecraft.name_tag": "taga ainme",
  "item.minecraft.command_block_minecart": "cairt-mhèinnearachd le bloca-àithne",
  "item.minecraft.mutton": "feòil-chaorach amh",
  "item.minecraft.cooked_mutton": "feòil-chaorach ròiste",
  "block.minecraft.white_banner": "bratach gheal",
  "block.minecraft.orange_banner": "bratach orains",
  "block.minecraft.magenta_banner": "bratach mhaidèanta",
  "block.minecraft.light_blue_banner": "bratach bhàn-ghorm",
  "block.minecraft.yellow_banner": "bratach bhuidhe",
  "block.minecraft.lime_banner": "bratach bhàn-uaine",
  "block.minecraft.pink_banner": "bratach bhàn-dearg",
  "block.minecraft.gray_banner": "bratach ghlas",
  "block.minecraft.light_gray_banner": "bratach liath",
  "block.minecraft.cyan_banner": "bratach shaidhean",
  "block.minecraft.purple_banner": "bratach phurpaidh",
  "block.minecraft.blue_banner": "bratach ghorm",
  "block.minecraft.brown_banner": "bratach dhonn",
  "block.minecraft.green_banner": "bratach uaine",
  "block.minecraft.red_banner": "bratach dhearg",
  "block.minecraft.black_banner": "bratach dhubh",
  "item.minecraft.end_crystal": "criostal end",
  "item.minecraft.chorus_fruit": "meas-sèiste",
  "item.minecraft.popped_chorus_fruit": "meas-sèiste briste",
  "item.minecraft.beetroot": "biatas",
  "item.minecraft.beetroot_seeds": "sìl biatais",
  "item.minecraft.beetroot_soup": "brot biatais",
  "item.minecraft.dragon_breath": "anail dràgoin",
  "item.minecraft.splash_potion": "deoch-thilgidh nach gabh dèanamh le ceàrd□gun bhuadh",
  "item.minecraft.spectral_arrow": "saighead luisnidh",
  "item.minecraft.tipped_arrow": "saighead sheunta nach dèanar le obair-chiùird□gun bhuadh",
  "item.minecraft.lingering_potion": "deoch-fhuireachd nach gabh dèanamh le ceàrd□gun bhuadh",
  "item.minecraft.shield": "sgiath",
  "item.minecraft.elytra": "sgiathanan",
  "item.minecraft.spruce_boat": "bàta giuthais",
  "item.minecraft.birch_boat": "bàta beithe",
  "item.minecraft.jungle_boat": "bàta dlùth-choille",
  "item.minecraft.acacia_boat": "bàta sitta",
  "item.minecraft.dark_oak_boat": "bàta daraich dhuirch",
  "item.minecraft.totem_of_undying": "tòtam dìona o bhàs",
  "item.minecraft.shulker_shell": "slige shulker",
  "item.minecraft.iron_nugget": "cnapan iarainn",
  "item.minecraft.knowledge_book": "leabhar-eòlais",
  "item.minecraft.debug_stick": "slat dì-bhugachaidh",
  "item.minecraft.music_disc_13": "clàr ciùil□c418 - 13",
  "item.minecraft.music_disc_cat": "clàr ciùil□c418 - cat",
  "item.minecraft.music_disc_blocks": "clàr ciùil□c418 - blocks",
  "item.minecraft.music_disc_chirp": "clàr ciùil□c418 - chirp",
  "item.minecraft.music_disc_far": "clàr ciùil□c418 - far",
  "item.minecraft.music_disc_mall": "clàr ciùil□c418 - mall",
  "item.minecraft.music_disc_mellohi": "clàr ciùil□c418 - mellohi",
  "item.minecraft.music_disc_stal": "clàr ciùil□c418 - stal",
  "item.minecraft.music_disc_strad": "clàr ciùil□c418 - strad",
  "item.minecraft.music_disc_ward": "clàr ciùil□c418 - ward",
  "item.minecraft.music_disc_11": "clàr ciùil□c418 - 11",
  "item.minecraft.music_disc_wait": "clàr ciùil□c418 - wait",
  "item.minecraft.music_disc_pigstep": "clàr ciùil□lena raine - pig cheum",
  "item.minecraft.trident": "muirgheadh□□anns a' phrìomh làimh:□+8 dochann ionnsaighe□-2.9 luaths ionnsaighe",
  "item.minecraft.phantom_membrane": "meamran tannaisg",
  "item.minecraft.nautilus_shell": "slige faochaige",
  "item.minecraft.heart_of_the_sea": "cridhe na mara",
  "item.minecraft.crossbow": "crois-bhogha",
  "item.minecraft.suspicious_stew": "stiubha amharasach",
  "block.minecraft.loom": "beart-fhighe",
  "item.minecraft.flower_banner_pattern": "pàtran brataiche□aogas flùir",
  "item.minecraft.creeper_banner_pattern": "pàtran brataiche□aogas creeper",
  "item.minecraft.skull_banner_pattern": "pàtran brataiche□aogas claiginn",
  "item.minecraft.mojang_banner_pattern": "pàtran brataiche□rud",
  "item.minecraft.globe_banner_pattern": "pàtran brataiche□globa",
  "item.minecraft.piglin_banner_pattern": "pàtran brataiche□gnos",
  "block.minecraft.composter": "inneal-compoist",
  "block.minecraft.barrel": "baraille",
  "block.minecraft.smoker": "smocair",
  "block.minecraft.blast_furnace": "fùirneis sèididh",
  "block.minecraft.cartography_table": "bòrd cairt-iùlachd",
  "block.minecraft.fletching_table": "bòrd fleistearachd",
  "block.minecraft.grindstone": "clach-bhleith",
  "block.minecraft.lectern": "leatran",
  "block.minecraft.smithing_table": "bòrd goibhneachd",
  "block.minecraft.stonecutter": "gearradair-cloiche",
  "block.minecraft.bell": "clag",
  "block.minecraft.lantern": "lòchran",
  "block.minecraft.soul_lantern": "lòchran anama",
  "item.minecraft.sweet_berries": "dearcan milis",
  "block.minecraft.campfire": "teine fosgailte",
  "block.minecraft.soul_campfire": "teine-anama fosgailte",
  "block.minecraft.shroomlight": "solas-buachair",
  "item.minecraft.honeycomb": "cìr-mheala",
  "block.minecraft.bee_nest": "nead sheillean",
  "block.minecraft.beehive": "sgeap",
  "item.minecraft.honey_bottle": "botal meala",
  "block.minecraft.honey_block": "bloca meala",
  "block.minecraft.honeycomb_block": "bloca cìre-meala",
  "block.minecraft.lodestone": "clach-iùil",
  "block.minecraft.netherite_block": "bloca netherit",
  "block.minecraft.ancient_debris": "smodal àrsaidh",
  "block.minecraft.target": "targaid",
  "block.minecraft.crying_obsidian": "oibsidian caoinidh",
  "block.minecraft.blackstone": "dubh-chlach",
  "block.minecraft.blackstone_slab": "leac dubh-chloiche",
  "block.minecraft.blackstone_stairs": "staidhre dubh-chloiche",
  "block.minecraft.gilded_blackstone": "dubh-chlach òraichte",
  "block.minecraft.polished_blackstone": "dubh-chlach lìomhta",
  "block.minecraft.polished_blackstone_slab": "leac dubh-chloiche lìomhta",
  "block.minecraft.polished_blackstone_stairs": "staidhre dubh-chloiche lìomhta",
  "block.minecraft.chiseled_polished_blackstone": "dubh-chlach lìomhta ghilbichte",
  "block.minecraft.polished_blackstone_bricks": "breigichean dubh-chloiche lìomhta",
  "block.minecraft.polished_blackstone_brick_slab": "leac bhreigichean dubh-chloiche lìomhta",
  "block.minecraft.polished_blackstone_brick_stairs": "staidhre bhreigichean dubh-chloiche lìomhta",
  "block.minecraft.cracked_polished_blackstone_bricks": "breigichean dubh-chloiche sgagach lìomhta",
  "block.minecraft.respawn_anchor": "acair ath-ghintinn",
}
export const gd_gb = items; 
